export enum Roles {
  ADMIN = 'admin',
  SUPPORT = 'support'
}

export enum CourseTypeDurations {
  MONTHS = 'months',
  DAYS = 'days',
  YEARS = 'years',
  HOURS = 'hours',
  YEAR = 'year',
  WEEKS = 'weeks',
  MINUTES = 'minutes'
}
